/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Directive, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Callback, IErrorObject} from "../../../../../types/platform/universe";
import {BelongsDialogComponent} from "./belongs-dialog.component";

import {GuestsService} from "../../guests/guests.service";

/**
 * todo
 */
@Directive({
	selector: "[belongs-dialog]",
})

export class BelongsDialogDirective {

	@Input() public account: any;
	@Input() public auth: number;
	@Output() public success = new EventEmitter<any>();
	@Output() public error = new EventEmitter<any>();

	constructor(
		private matDialog: MatDialog,
		private accountService: GuestsService,
		//private accountService: Guests2Service,		// todo:guests2
	) {
	}

	/**
	 * todo
	 */
	private Complete(type: string, value: any): void {
		this.success.emit({type, value});
	}

	/**
	 * todo
	 */
	private Error(type: string, value: any): void {
		this.error.emit({type, value});
	}

	/**
	 * アカウント参照
	 * @param id
	 * @param callback
	 */
	private get(id: string, callback: Callback<object>): void {
		this.accountService.get_user(id, (error: IErrorObject, result: object): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * todo
	 */
	@HostListener("click", ["$event.target"])
	public belongsDialog(): void {
		const dialog: MatDialogRef<any> = this.matDialog.open(BelongsDialogComponent, {
			width: "fit-content",
			height: "fit-content",
			data: {
				auth: this.auth,
				account: this.account,
			},
			disableClose: true,
		});

		dialog.beforeClosed().subscribe((result: any): void => {
			if (result) { // if not cancel then

			}
		});

		dialog.afterClosed().subscribe((result: object): void => {
			if (result) {
				this.Complete("", result);
			}
		});
	}

}
